<template>
  <trac-modal @close="$emit('close')">
    <h4 class="font-bold mb-3">Product Details</h4>
    <div
      class="grid grid-cols-12 gap-x-3 gap-y-2 border rounded-md border-gray-200 mb-5 p-3 text-xs"
    >
      <div class="col-span-4">
        <p class="font-bold">Total Quantity</p>
        <span class="text-primaryGray">
          {{ product.stockQuantity }}
        </span>
      </div>
      <div class="col-span-4">
        <p class="font-bold">Cost Price</p>
        <span class="text-primaryGray">
          {{ product.costPrice | formatPrice }}
        </span>
      </div>
      <div class="col-span-4">
        <p class="font-bold">Sale Price</p>
        <span class="text-primaryGray">
          {{ product.salePrice | formatPrice }}
        </span>
      </div>
      <div class="col-span-4">
        <p class="font-bold">Category</p>
        <span class="text-primaryGray">
          {{ product.categories.name }}
        </span>
      </div>
      <div class="col-span-4">
        <p class="font-bold">Last Updated</p>
        <span class="text-primaryGray">
          {{ moment(product.updatedAt).format('Do MMM, YYYY hh:mma') }}
        </span>
      </div>
      <div class="col-span-4">
        <p class="font-bold">SKU / Barcode</p>
        <span class="text-primaryGray">{{ product.barcode }}</span>
      </div>
    </div>

    <h5 class="font-bold mb-1 text-sm">Store Details</h5>
    <table class="w-full table-auto mb-2">
      <thead class="bg-blue-100">
        <tr>
          <th class="text-left whitespace-no-wrap p-4 text-xs font-semibold">
            Store(s)
          </th>
          <th class="text-left whitespace-no-wrap p-4 text-xs font-semibold">
            Qty
          </th>
          <th class="text-left whitespace-no-wrap p-4 text-xs font-semibold">
            Reorder Level
          </th>
        </tr>
      </thead>
      <tbody v-if="product.storeStock && product.storeStock.length">
        <tr
          v-for="(store, index) in product.storeStock"
          :key="store.storeID"
          :class="index % 2 === 0 ? '' : 'bg-gray-100'"
          class="cursor-pointer hover:bg-gray-200"
        >
          <td class="text-xs p-4 font-bold capitalize">
            {{ store.storeName }}
          </td>
          <td class="text-xs p-4 font-bold capitalize">
            {{ store.stockQuantity }}
          </td>
          <td class="text-xs p-4 font-bold capitalize">
            {{ store.reOrderLevel }}
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td class="text-xs font-medium p-4" colspan="6">
            <trac-center-data>
              <div class="h-5 flex items-center text-xs text-gray-600">
                There is no data available.
              </div>
            </trac-center-data>
          </td>
        </tr>
      </tbody>
    </table>
  </trac-modal>
</template>

<script>
import moment from 'moment';

export default {
  name: 'StockDetails',
  props: {
    product: {
      type: Object,
      default: {},
    },
  },
  emits: ['close'],
  data() {
    return {
      moment,
    };
  },
};
</script>

<style scoped></style>
